import {
  startTracking,
  getBufferedEvents,
  clearBufferedEvents,
} from "./tracker";

export function initEventLogger({
  events = ["click", "scroll", "input"],
  flushInterval = 5000,
  onFlush,
}) {
  startTracking({ events });

  if (typeof onFlush !== "function") {
    console.warn("[eventLogger] No onFlush handler provided");
    return;
  }

  setInterval(() => {
    const events = getBufferedEvents();
    if (events.length > 0) {
      onFlush(events);
      clearBufferedEvents();
    }
  }, flushInterval);
}
